import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "user-menu"
}
const _hoisted_2 = { class: "user-info" }
const _hoisted_3 = { class: "user-display-name" }
const _hoisted_4 = { class: "user-name" }

import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import FormButton from '@/components/common/button/FormButton.vue';
import { spainAuthenticationEndpoints } from '@/core/endpoints';
import EventConstants from '@/core/eventConstants';
import { AuthMethods } from '@/models/auth-methods';
import authService from '@/services/AuthService';
import navigationService from '@/services/NavigationService';
import { useAuthStore } from '@/stores/authStore';
import { AuthUtils } from '@/utils/auth.utils';
import eventEmitter from '@/utils/eventEmitter';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserIcon',
  setup(__props) {

const { t } = useI18n();
const { authMethod, products } = useAuthStore();

const showOptions = ref(false);
let hideTimeout: NodeJS.Timeout | null = null;

const handleMouseEnter = () => {
  if (hideTimeout) {
    clearTimeout(hideTimeout);
    hideTimeout = null;
  }
  showOptions.value = true;
};

const handleMouseLeave = () => {
  hideTimeout = setTimeout(() => {
    showOptions.value = false;
  }, 150);
};

const logout = () => {
  eventEmitter.emit(EventConstants.LOGOUT_EVENT);
  navigationService.navigateTo({
    name: AuthUtils.getLoginRouteName(authMethod)
  });
};

const showSpainLogout = async () => {
  const backendLoginUrl = `${process.env.VUE_APP_API_URL}${spainAuthenticationEndpoints.LOGOUT}`;

  Office.context.ui.displayDialogAsync(
    backendLoginUrl,
    { height: 80, width: 80, promptBeforeOpen: false },
    (asyncResult) => {
      const dialog = asyncResult.value;
      dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
        if ('message' in arg && arg.message.includes('logged-out')) {
          dialog.close();
          logout();
        }
      });
      dialog.addEventHandler(Office.EventType.DialogEventReceived, () => {
        dialog.close();
        logout();
      });
    }
  );
};

const handleLogout = async () => {
  showOptions.value = false;

  if (authMethod === AuthMethods.Spain) {
    showSpainLogout();
  } else {
    authService.franceLogout();
    logout();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "user-icon-wrapper",
    onMouseenter: handleMouseEnter,
    onMouseleave: handleMouseLeave
  }, [
    _createVNode(AppIcon, {
      name: "user",
      size: "body-xl",
      "class-name": "color-lighter",
      clickable: true
    }),
    (showOptions.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(products).displayName), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(products).userName), 1)
          ]),
          _createVNode(FormButton, {
            label: _unref(t)('user_settings.logout'),
            type: "primary",
            "class-name": "logout-button",
            "on-click": handleLogout
          }, null, 8, ["label"])
        ]))
      : _createCommentVNode("", true)
  ], 32))
}
}

})